export const CONSTANTS = {
    SELECT_DEALERSHIP: "Select the dealership locations for which you want to manage API integrations, you've selected ",
    PRIVACY_PROTECTION_DESCRIPTION: "By opting in for Consumer Privacy Protection, you can limit sharing of your customer data with the app publisher.",
    MANAGE_API_FIELDS_DESCRIPTION: "The API fields are configured by the app developer for optimal performance. Any modifications may impact the app's functionality.",
    DEALERSHIP_LOCATION: "Dealership Location",
    ADDRESS: "Address",
    REVIEW_TERMS_HEADER: "Data Integration Agreement",
    REVIEW_TERMS_DESCRIPTION: 'Review and accept the terms below to enable API integration',
    REVIEW_TERMS_HEADER_DESCRIPTION: "API used in this app needs permission to access your dealership data.",
    TERMS_AND_CONDITIONS: 'Terms and Conditions',
    REVIEW_TERMS_FOOTER_TEXT: 'By clicking “yes”, you represent and warrant that you are authorized to agree to these terms and conditions on behalf of the dealership(s) you selected.',
    API_NAME: 'API Name',
    PRIVACY_PROTECTION_HEADER_NAME: 'Opt-in for Privacy Protection',
    INTEGRATION_STATUS: "Integration Status",
    INTEGRATION_STATUS_DESCRIPTION: "Enable or disable the app's access to the API.",
    enabled: "enabled",
    enable: "enable",
    disable: "disable",
    SELECT_LOCATIONS: 'Select Location(s)',
    DEALERSHIP_LOCATIONS: 'Dealership Location(s)',
    ACCEPT_TERMS_LOADER_TEXT: 'Consenting...',
    REVIEW_TERMS: 'Agree Terms',
    DMS_ACCOUNTS: 'Manage DMS',
    PRIVACY_PROTECTION: 'Configure CPP',
    API_FIELDS: 'Configure Fields',
    API_SUBSCRIPTION_SETTINGS: 'Manage API Subscription Settings',
    PROVISIONING_STATUS: 'Provisioning Status',
    ASYNC_API: 'async-api',
    PROVISIONING_STATUS_DESCRIPTION: 'Indicates if the API Publisher has provisioned your access to the Async API.',
    STATUS_TO_INDICATOR_VARIANT_MAP: {
        active: 'POSITIVE',
        inactive: 'NEGATIVE',
    },
    DEFAULT_INDICATOR_VARIANT: 'WARNING',
    DEFAULT_PROVISIONING_STATUS: 'Unknown',
    DISABLED: 'disabled',
};
